import { useContext } from 'react';
import { MentorStatus } from '../../api/mentors';
import { useMentorsContext } from '../../contexts/mentors-context';
import { useResourceBundles } from '../../contexts/resource-bundles-context';
import { UserContext } from '../../contexts/user-context';
import ChangeStatusModal from '../common/change-status-modal';

function MentorArchiveModal() {
  const { rb } = useResourceBundles();
  const { hasAccessToAction } = useContext(UserContext);
  const {
    isChangingMentorStatus,
    archiveTargetMentors,
    changeMentorStatus,
    setArchiveTargetMentors,
  } = useMentorsContext();

  const length = archiveTargetMentors?.length || 0;

  return hasAccessToAction('mentor.details.update') ? (
    <ChangeStatusModal
      open={!!archiveTargetMentors}
      title={`Archive ${rb('mentors')}`}
      text={`Do you really want to archive ${length} ${
        length === 1 ? rb('mentor') : rb('mentors')
      }?`}
      loading={isChangingMentorStatus}
      onClose={() => setArchiveTargetMentors(null)}
      onSubmit={() => changeMentorStatus(MentorStatus.ARCHIVED)}
    />
  ) : null;
}

export default MentorArchiveModal;
